import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back");
      navigate("/admin");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="dash min-h-screen flex items-center justify-center px-6" data-testid="admin-login">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="w-full max-w-md"
      >
        <Link to="/" className="font-head font-extrabold tracking-tighter text-2xl">OUTDOEM<span className="text-[#005CEE]">.</span></Link>
        <p className="font-mono2 text-xs tracking-[0.25em] text-[#94A3B8] mt-6 mb-2">ADMIN ACCESS</p>
        <h1 className="font-head font-extrabold tracking-tighter text-4xl mb-8">Dashboard login</h1>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="block text-xs font-mono2 tracking-widest text-[#94A3B8] mb-2">EMAIL</label>
            <input value={email} onChange={(e) => setEmail(e.target.value)} type="email"
              className="w-full bg-[#111827] border border-[#1E293B] rounded-xl px-4 py-3 text-sm outline-none focus:border-[#005CEE] transition-colors"
              data-testid="login-email" />
          </div>
          <div>
            <label className="block text-xs font-mono2 tracking-widest text-[#94A3B8] mb-2">PASSWORD</label>
            <input value={password} onChange={(e) => setPassword(e.target.value)} type="password"
              className="w-full bg-[#111827] border border-[#1E293B] rounded-xl px-4 py-3 text-sm outline-none focus:border-[#005CEE] transition-colors"
              data-testid="login-password" />
          </div>
          <button type="submit" disabled={loading}
            className="w-full bg-[#005CEE] hover:bg-[#0047b8] transition-colors rounded-xl py-3 text-sm font-semibold disabled:opacity-60"
            data-testid="login-submit">
            {loading ? "Signing in…" : "Sign In"}
          </button>
        </form>
        <Link to="/" className="block mt-6 text-center text-xs font-mono2 text-[#94A3B8] hover:text-white transition-colors">← Back to site</Link>
      </motion.div>
    </div>
  );
}
